import { useEffect, useState } from "react"
import FlexRow from "../../../components/base/FlexRow"
import ChatContactItem from "../models/ChatContactItem"
import Technician from "../../technicians/models/technician"
import { canListActiveJobs, isDemo, openJobQuickView, useHub, useStatusesForChatTechJobs } from "../../../core/Global"
import { API_ROUTES } from "../../../core/Constants"
import Icon from "../../../components/base/Icon"
import Job from "../../crm/jobs/models/Job"
import ChatJobCard from "./ChatJobCard"
import JobStatus from "../../crm/base/models/JobStatus"
import ChatAvatarSpan from "./ChatAvatarSpan"
import { ChatEnvironments } from "../../../core/Enums"


interface IProps {
    chat?: ChatContactItem
    chatId?: string
}

// A line number the way the US writes it, country code first: "+1 (551) 243-6037".
// Anything that is not a 10-digit NANP number (with or without the leading 1) is shown as it is.
const friendlyLine = (value?: string): string => {
    if (!value) return ""
    var d = value.replace(/\D/g, "")
    if (d.length == 11 && d.startsWith("1")) d = d.substring(1)
    if (d.length != 10) return value
    return `+1 (${d.substring(0, 3)}) ${d.substring(3, 6)}-${d.substring(6)}`
}

// crm/chat/senderline/{chatId}
interface ChatSenderLine {
    lineId?: string
    phoneNumber?: string
    friendlyName?: string
    tollFree?: boolean
    region?: string
    source?: { id?: string, name?: string }
}

export default function ChatTechBox(props: IProps) {

    const hub = useHub();

    const [boxHeight, boxHeightSet] = useState<number>();
    const [jobsHeight, jobsHeightSet] = useState<number>();
    const fixSizes = () => {
        var w = $(window).width() ?? 500;
        var h = $(window).height() ?? 400;
        if (w < 500) {
            h = 250;
        }
        else {
            h = h - ($("#kt_header").outerHeight() ?? 50);
            // h = h - ($("#kt_toolbar").outerHeight() ?? 50);
            // h = h - 40;
        }
        boxHeightSet(h);

        var j = h - 120;
        $(".chat-techbox-items").each((i, el) => {
            j = j - ($(el).outerHeight() ?? 50)
            //j = j - ($(el).innerHeight() ?? 50)
        })
        jobsHeightSet(j);
    }

    useEffect(() => {
        fixSizes();
        window.addEventListener("resize", fixSizes);

        return () => {
            window.removeEventListener("resize", fixSizes);
        }

    }, [])


    const [tech, techSet] = useState<Technician>();
    const [jobs, jobsSet] = useState<Job[]>([]);

    // The account's own line a GSM chat runs on, with the job source it is assigned to.
    // Fetched per chat rather than carried on the chat item, so a line moved to another
    // source shows the new source the next time the chat is opened.
    const [senderLine, senderLineSet] = useState<ChatSenderLine>();
    useEffect(() => {
        senderLineSet(undefined);
        if (!props.chat?.id || props.chat.environment != ChatEnvironments.GSM) return;
        const chatId = props.chat.id;
        hub.Get(API_ROUTES.Chat + "senderline/" + chatId, res => {
            if (res.success && chatId == props.chat?.id) senderLineSet(res.data);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.chat?.id, props.chat?.environment])

    // The settings block grows by a row once the line (and its source) arrive, and the jobs
    // list height is what absorbs that -- otherwise the new row sits below the fold.
    useEffect(() => {
        fixSizes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [senderLine])
    const statuses = useStatusesForChatTechJobs();
    const [selectedStatus, selectedStatusSet] = useState<JobStatus>();

    useEffect(() => {
        if (!selectedStatus && statuses.length > 0) selectedStatusSet(statuses[0])
    }, [statuses])


    const fetchTech = () => {
        hub.Get(API_ROUTES.Technicians + props.chat?.tech?.id, res => {
            if (res.success) techSet(res.data);
        })
    }
    const fetchJobs = (stId: string) => {
        if (!props.chat?.tech?.id || !canListActiveJobs()) {
            jobsSet([]);
            return;
        }
        var q = "";
        if (stId) q = "?statusId=" + stId;
        hub.Get(API_ROUTES.Jobs + "techactivejobs/" + props.chat.tech.id + q, res => {
            if (res.success) jobsSet(res.data);
        })
    }


    useEffect(() => {
        if (props.chat?.tech?.id) {
            fetchTech();
        }
    }, [props.chat?.id])


    useEffect(() => {
        if (selectedStatus?.id) {
            fetchJobs(selectedStatus.id);
        }
    }, [props.chat?.id, selectedStatus])

    useEffect(() => {
        fixSizes();
    }, [tech])

    return (
        <>
            <div className="card" style={{
                height: boxHeight,
                borderRadius: 0
            }}>
                <div className="card-body">

                    <FlexRow className="chat-techbox-items">
                        {
                            props.chat?.tech?.avatarUrl ?
                                <div className="symbol symbol-75px symbol-circle">
                                    <img alt={props.chat.tech?.fullName} src={props.chat.tech?.avatarUrl} />
                                </div>
                                :
                                <div className="symbol symbol-75px symbol-circle">
                                    {/* <span className="symbol-label bg-light-danger text-danger fw-bolder" style={{ fontSize: "30px" }}>{props.chat?.title?.substring(0, 1).toUpperCase()}</span> */}
                                    <ChatAvatarSpan item={props.chat} size={28} />
                                </div>
                        }

                        <div className="ms-2">
                            <div className="fs-3 fw-bolder text-gray-900 me-1 mb-2">
                                {isDemo() ? "Tech " + props.chat?.title?.substring(0, 2).toUpperCase() : props.chat?.title}
                            </div>
                            {
                                props.chat?.isGroup ?
                                    <>
                                        {
                                            props.chat.environment == ChatEnvironments.WhatsApp &&
                                            <FlexRow className="fs-7 text-muted">
                                                <Icon icon="whatsapp" className="me-1" type="brands" />
                                                <span>
                                                    WhatsApp Group
                                                </span>
                                            </FlexRow>
                                        }
                                        {
                                            props.chat.environment == ChatEnvironments.Telegram &&
                                            <FlexRow className="fs-7 text-muted">
                                                <Icon icon="telegram" className="me-1" type="brands" />
                                                <span>
                                                    Telegram Group
                                                </span>
                                            </FlexRow>
                                        }
                                    </>
                                    :
                                    <div className="fs-7 text-muted">
                                        {isDemo() ? "+1 (222) 333 4455" : props.chat?.recipientPhone}
                                    </div>
                            }

                        </div>

                    </FlexRow>

                    {
                    // The technician's active jobs need ListActiveJobs.
                    canListActiveJobs() &&
                    <>
                    <hr className="chat-techbox-items" />

                    <div>
                        <FlexRow className="chat-techbox-items">
                            <div className="fw-bolder fs-6">Active Jobs</div>
                            <div className="fs-8 ms-auto cursor-pointer" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                <Icon icon="circle" type="solid" className="me-1" size={10} color={selectedStatus?.color ?? "#555"} />
                                <span>{selectedStatus?.name ?? "All Active Jobs"}</span>
                                <Icon icon="chevron-down" className="ms-2" size={10} />
                            </div>
                            <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-2" data-kt-menu="true">
                                {
                                    statuses?.map((st, k) =>
                                        <div key={k} className="menu-item">
                                            <a href="#" className="menu-link px-3"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    selectedStatusSet(st);
                                                }}>
                                                <Icon icon="circle" type="solid" className="me-2" size={10} color={st.color} />
                                                {st.name}
                                            </a>
                                        </div>
                                    )
                                }
                                {/* <div className="menu-item">
                                    <a href="#" className="menu-link px-3"
                                        onClick={e => {
                                            e.preventDefault();
                                            selectedStatusSet(undefined);
                                            fetchJobs();
                                        }}>
                                        <Icon icon="circle" type="solid" className="me-2" size={10} color="#555" />
                                        All Active Jobs
                                    </a>
                                </div> */}
                            </div>
                            {/* <select className="form-select form-select-sm ms-auto" style={{width: 120}}>
                                <option value="inprogress">In Progress</option>
                                <option value="appointments">Appointments</option>
                                <option value="all">All Active Jobs</option>
                            </select> */}
                        </FlexRow>

                        {
                            jobs.length > 0 ?
                                <div className="my-5 scroll-y"
                                    style={{
                                        height: jobsHeight
                                    }}>
                                    {
                                        jobs.map(job =>
                                            <ChatJobCard key={"chat-job-card-" + job.id}
                                                id={job.id}
                                                onEdit={j => {
                                                    openJobQuickView(j.id)
                                                }}
                                                onRemove={j => {
                                                    var arr = jobs ?? [];
                                                    var index = -1;
                                                    for (var i = 0; i < arr.length; i++) {
                                                        if (j.id == arr[i].id) {
                                                            index = i;
                                                            break;
                                                        }
                                                    }

                                                    if (index > -1) {
                                                        arr.splice(index, 1);
                                                        jobsSet(a => [...arr]);
                                                    }
                                                }}
                                            />
                                        )
                                    }
                                </div>
                                :
                                <div className="my-5 pt-10 text-center"
                                    style={{
                                        height: jobsHeight
                                    }}>
                                    There are no active jobs.
                                </div>
                        }
                    </div>
                    </>
                    }

                    <hr className="chat-techbox-items" />

                    <div className="chat-techbox-items">
                        <h4>Chat Settings</h4>
                        <div className="pt-5 pb-5">
                            {
                                props.chat?.isGroup &&
                                <>
                                    {
                                        props.chat.environment == ChatEnvironments.WhatsApp &&
                                        <FlexRow className="mb-3">
                                            <Icon icon="whatsapp" className="me-2" type="brands" />
                                            <span>
                                                WhatsApp Group
                                            </span>
                                        </FlexRow>
                                    }
                                    {
                                        props.chat.environment == ChatEnvironments.Telegram &&
                                        <FlexRow className="mb-3">
                                            <Icon icon="telegram" className="me-2" type="brands" />
                                            <span>
                                                Telegram Group
                                            </span>
                                        </FlexRow>
                                    }
                                    <FlexRow className="mb-3">
                                        <Icon icon="user-helmet-safety" className="me-2" type="solid" />
                                        <span>
                                            Created By {props.chat.tech?.fullName}
                                        </span>
                                    </FlexRow>
                                </>
                            }
                            {
                                props.chat?.environment == ChatEnvironments.GSM ?
                                    <>
                                        <FlexRow className="mb-3">
                                            <Icon icon="comment-lines" className="me-2" type="solid" />
                                            Send By GSM
                                        </FlexRow>
                                        {/* "Line", not "Sender": this is the account's own number --
                                            the customer's messages come in on it and replies go out
                                            from it -- so naming it the sender read as if it were the
                                            other party. */}
                                        <FlexRow className={(senderLine?.tollFree || senderLine?.region || senderLine?.source) ? "mb-3" : ""}>
                                            <Icon icon="phone-rotary" className="me-2" type="solid" />
                                            <div className="fs-8">
                                                Line: {friendlyLine(senderLine?.phoneNumber ?? props.chat?.senderPhone)}
                                            </div>
                                        </FlexRow>
                                        {
                                            (senderLine?.tollFree || senderLine?.region) &&
                                            <FlexRow className={senderLine?.source ? "mb-3" : ""}>
                                                <Icon icon="location-dot" className="me-2" type="solid" />
                                                <div className="fs-8">
                                                    {senderLine.tollFree ? "Toll-Free" : senderLine.region}
                                                </div>
                                            </FlexRow>
                                        }
                                        {
                                            senderLine?.source &&
                                            <FlexRow>
                                                <Icon icon="bullhorn" className="me-2" type="solid" />
                                                <div className="fs-8">
                                                    Source: {senderLine.source.name}
                                                </div>
                                            </FlexRow>
                                        }
                                    </>
                                    : props.chat?.environment == ChatEnvironments.App ?
                                        <>
                                            <FlexRow>
                                                <Icon icon="mobile-alt" className="me-2" />
                                                Send By Rinvox App
                                            </FlexRow>
                                        </>
                                        : <></>
                            }

                        </div>
                    </div>


                </div>
            </div>


        </>
    )
}